import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import user from '../services/session/reducer';

const reducers = {
    routing: routerReducer,
    form : reduxFormReducer,
    user : persistReducer({
        key: "user", // key for localStorage key, will be: "persist:form"
        storage,
        debug: true,
        whitelist: ['lastTimeActitity'],
    },user),
};

module.exports = combineReducers(reducers);



// WEBPACK FOOTER //
// ./src/reducers/index.js